import { format } from 'date-fns';
import { de, enUS, es, fr, it, nl, pl, pt, ro, uk } from 'date-fns/locale';
import i18next from 'i18next';

// One entry per language of i18n.js supportedLngs. Keys are the UI language codes, values
// the date-fns locales — the two differ for English and for Ukrainian, which date-fns
// ships as `uk` while the UI calls it `ua`.
const DATE_FNS_LOCALES = { de, en: enUS, es, fr, it, nl, pl, pt, ro, ua: uk };

export const getDateFnsLocale = (language) => DATE_FNS_LOCALES[language?.split('-')[0]] ?? fr;

// PPPP is the locale's own full-date format, so each language keeps its conventions
// ("23. September" in German, "23 de septiembre de" in Spanish). Most of them start
// lowercase, which reads wrong at the head of a page title.
export const getFormattedFullDate = (date = new Date(), language = i18next.language) => {
    const formatted = format(date, 'PPPP', { locale: getDateFnsLocale(language) });
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

export const getFormattedDateWithOffset = ({ from = 0 }) => {
    const today = new Date();
    const endDate = new Date(today);
    endDate.setDate(today.getDate() + from);

    const day = String(endDate.getDate()).padStart(2, '0');
    const month = String(endDate.getMonth() + 1).padStart(2, '0');
    const year = endDate.getFullYear();

    return `${day}/${month}/${year}`;
};

export const getFormattedDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

export const getFormatDateTime = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatDate = (iso) =>
    new Date(iso).toLocaleDateString(i18next.language || 'fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });

export const formatDateTime = (iso) =>
    new Date(iso).toLocaleString(i18next.language || 'fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });

export const formatTime = (iso) => new Date(iso).toLocaleTimeString(i18next.language || 'fr-FR', { hour: '2-digit', minute: '2-digit' });

export const getIsoDateInDays = (days) => new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString();

export const getDaysBetweenDates = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const timeDiff = end - start;

    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    return daysDiff;
};
